import {
	Component,
	Input,
	OnDestroy,
	OnInit,
	Signal,
	ViewEncapsulation,
	signal,
	ViewChild,
	ElementRef,
	AfterViewInit,
} from '@angular/core';
import { FormGroup, UntypedFormBuilder } from '@angular/forms';

interface Scope {
	loading: Signal<boolean>;
}

@Component({
	selector: 'ms-input-textarea',
	templateUrl: './ms-input-textarea.component.html',
	styleUrls: ['./ms-input-textarea.component.scss'],
	encapsulation: ViewEncapsulation.None,
	standalone: false,
})
export class MsInputTextareaComponent implements OnInit, OnDestroy, AfterViewInit {
	@Input() formGroup: FormGroup;
	@Input() title: string;
	@Input() key: string;
	@Input() placeholder?: string;
	@Input() iconLeft: string;
	@Input() iconRight: string;
	@Input() class: string;
	@Input() rows: number;
	@Input() autoResize: boolean;
	@Input('autoFocus') _autoFocus: boolean;

	@ViewChild('textarea')
	private _textarea: ElementRef;

	scope: Scope = {
		loading: signal(true),
	};

	/**
	 * Constructor
	 */
	constructor(private _formBuilder: UntypedFormBuilder) {
		if (!this.formGroup) {
			this.key = 'name';
			this.formGroup = this._formBuilder.group({
				name: [null, []],
			});
		}
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Lifecycle hooks
	// -----------------------------------------------------------------------------------------------------

	/**
	 * On init
	 */
	ngOnInit(): void {
		this.scope.loading = signal(false);
		if (!this.placeholder) {
			this.placeholder = this.title;
		}
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {}

	/**
	 * On after view init
	 */
	ngAfterViewInit() {
		if (this._autoFocus) {
			this.focus();
		}
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Public methods
	// -----------------------------------------------------------------------------------------------------

	focus(): void {
		this._textarea.nativeElement.focus();
	}
	// -----------------------------------------------------------------------------------------------------
	// @ Private methods
	// -----------------------------------------------------------------------------------------------------
}
